import React from "react";
import { observer } from "mobx-react-lite";
import { useDependencyInjector } from "@whatslly/commons/di";
import classnames from "classnames";
import styles from "../../ChatComponent.module.scss";
import { ChatMessagesStore } from "../../../ChatComponent/stores/ChatMessagesStore";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";

export const ChatEntityFilterButton: React.FC<{ isOpen: boolean }> = observer(({ isOpen }) => {
  const chatMessagesStore = useDependencyInjector(ChatMessagesStore);
  return (
    <div
      data-testid="filter-personal-message-button"
      className={classnames(styles.headerButton, {
        [styles.selected]: isOpen,
        [styles.disabled]:
          !(chatMessagesStore.messages.state === "fulfilled" && chatMessagesStore.messages.value.length > 0) ||
          chatMessagesStore.userId.state !== "fulfilled",
      })}
    >
      <SvgV2 width={12} height={12} iconName={`filters-icon`} />
    </div>
  );
});
